/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, useEffect } from 'react';
import cx from 'classnames';
import { Header, Footer } from 'containers';
import {
  Route,
  RouteProps,
  useLocation,
} from 'react-router-dom';
import { routes, setPageMeta } from 'appConstants';
import styles from './styles.module.scss';

interface Props extends RouteProps {
  item: {
    root: string,
    title: string,
    descr: string,
  },
}

const PublicRoute: FC<Props> = ({ item, ...rest }) => {
  const location = useLocation();
  const mediaSectionRoots = [
    routes.media.news.root,
    routes.media.gallery.root,
    routes.media.articles.root,
    routes.media.specProjects.root,
    routes.media.techTours.root,
    routes.media.videoAlbums.root,
    routes.media.videoFaces.root,
    routes.media.videoLifeHacks.root,
    routes.media.videoWhatBuy.root,
    routes.media.videoAboutExport.root,
  ];
  const isMediaArticle = (
    location.pathname.startsWith(`${routes.media.root}/`) &&
    !mediaSectionRoots.some((root) => (
      location.pathname === root || location.pathname.startsWith(`${root}/`)
    ))
  );
  const isFlush = (
    location.pathname === routes.main.root ||
    location.pathname === routes.about.root ||
    location.pathname === routes.vacancies.root ||
    location.pathname === routes.contacts.root ||
    location.pathname === routes.resolutions.root ||
    location.pathname.startsWith(`${routes.resolutions.root}/`) ||
    location.pathname === routes.media.news.root ||
    mediaSectionRoots.some((root) => (
      location.pathname === root || location.pathname.startsWith(`${root}/`)
    )) ||
    isMediaArticle ||
    location.pathname === routes.events.root ||
    location.pathname.startsWith(`${routes.events.root}/`)
  );
  const headerTheme = isFlush ? 'dark' : 'light';

  useEffect(() => {
    if (location.pathname === item.root) {
      setPageMeta(item.title, item.descr);
    }
  }, [location.pathname, item.root, item.title, item.descr]);

  return (
    <>
      <Header theme={headerTheme} />
      <main className={cx(styles.main, isFlush && styles.mainFlush)}>
        <Route
          {...rest}
        />
      </main>
      <Footer />
    </>
  );
};

export default PublicRoute;
